import * as React from 'react';
import { ChaptersChart } from "./ChaptersChart";
import { QuestionCharts } from "./QuestionCharts";
import { PdfDownloadButton } from "./PdfDownloadButton";
import { ChartDataContext } from "../context/Chart";
import { Spinner } from "./Spinner";

export const Charts = (): JSX.Element => {

    const [chartdata,] = React.useContext(ChartDataContext);

    if(chartdata.result_set.filter((result_set) => result_set.passed_threshold).length===0) {
        return <p>Er zijn onvoldoende gegevens beschikbaar om voor de geselecteerde filter en periode informatie weer te geven.</p>
    }

    return <div className={'c-rstats__charts'}>
        {chartdata.fetching && (<Spinner title={'Bezig met het ophalen van de gegevens'}/>)}
        <PdfDownloadButton/>
        {chartdata.initialized && (<>
            <ChaptersChart/>
            <QuestionCharts/>
        </>)}
        <PdfDownloadButton/>
    </div>;
}
